// Styles partagés pour les tableaux StatsResults / MedidasResults
// Permet de garder une présentation cohérente entre les deux écrans.

export const makeHeaderSx = (clubPrimaryColor) => (colWidth) => ({
  backgroundColor: clubPrimaryColor,
  color: 'white',
  fontWeight: 700,
  width: colWidth ? `${colWidth}px` : '60px',
  minWidth: colWidth ? `${colWidth}px` : '60px',
  maxWidth: colWidth ? `${colWidth}px` : '60px',
  padding: '10px 4px',
  fontSize: '0.72rem',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  letterSpacing: '0.3px',
  borderBottom: 'none',
});

export const makeCellSx = (colWidth) => ({
  width: colWidth ? `${colWidth}px` : '60px',
  minWidth: colWidth ? `${colWidth}px` : '60px',
  maxWidth: colWidth ? `${colWidth}px` : '60px',
  padding: '6px 4px',
  fontSize: '0.72rem',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const tableContainerSx = {
  borderRadius: 2,
  boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
};

export const tableSx = {
  tableLayout: 'fixed',
  width: '100%',
  '& .MuiTableRow-root:hover': {
    backgroundColor: 'rgba(0,0,0,0.025) !important',
  },
};

// Avatar uniformisé desktop entre Stats (30) et Medidas (40) -> 34
export const DESKTOP_AVATAR_SIZE = 34;
